var map = {
	"./AllPlayers.svg": 8870,
	"./ArrowDown.svg": 3518,
	"./Bioluminescent.svg": 6196,
	"./Camouflage.svg": 6847,
	"./ConsumeFish.svg": 5401,
	"./ConsumeFish1.svg": 8858,
	"./ConsumeFish2.svg": 4441,
	"./ConsumeFish3.svg": 5288,
	"./Discard.svg": 5919,
	"./DrawCard.svg": 3587,
	"./Dusk.svg": 8004,
	"./Electric.svg": 9078,
	"./Estuary.svg": 1920,
	"./FishEgg.svg": 6492,
	"./FishFromHand.svg": 6782,
	"./FishHatch.svg": 321,
	"./FishLengthLarge.svg": 1838,
	"./FishLengthMedium.svg": 9512,
	"./FishLengthSmall.svg": 7058,
	"./FlipperBlue.svg": 1275,
	"./FlipperGreen.svg": 9568,
	"./FlipperPurple.svg": 9873,
	"./Night.svg": 2471,
	"./PlayFishBottomRow.svg": 9338,
	"./Predator.svg": 4730,
	"./SchoolFeederMove.svg": 9817,
	"./SchoolFish.svg": 9225,
	"./StarterIcon.svg": 4715,
	"./Sun.svg": 447,
	"./TuckedCardSolo.svg": 9800,
	"./Venomous.svg": 281,
	"./Wave.svg": 8152,
	"./YoungFish.svg": 5207
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6669;